import React, { useState, useEffect } from 'react';
import * as FishxIcons from '@fishx/icons';
import { createFromIconfontCN, PCheckOutlined } from '@fishx/icons';
import "@whalecloud/fdx-theme-fdx/icon-picker.less";

const allIcons: {
  [key: string]: any;
} = FishxIcons;
const IconList = ({
  dataSource,
  iconChange,
  currentIcon,
  setIconType,
  readonly,
  displayFromIconfontCN,
  showColorSelect,
  currentColor,
  colorChange,
}: {
  dataSource: Array<any>;
  iconChange?: Function;
  currentIcon?: any;
  setIconType?: Function;
  readonly?: Boolean;
  displayFromIconfontCN?: string;
  showColorSelect?: Boolean;
  currentColor?: string;
  colorChange?: Function;
}) => {
  const ColorList = ['#E91E63', '#FF9700', '#4EAF50', '#07BCD4', '#2196F3', '#9E27B1', '#4051B5', '#455A63']
  const [selectedColor, setSelectedColor] = useState(-1);
  const [backgroundColor, setBackgroundColor] = useState('');
  const [renderData, setRenderData] = useState(dataSource);
  const handleClick = (index) => {
    setBackgroundColor(ColorList[index]);
    colorChange(ColorList[index])
    setSelectedColor(index);
    if (iconChange) iconChange({ name: currentIcon, color: ColorList[index] });
  }
  const IconFont = createFromIconfontCN({
    scriptUrl: displayFromIconfontCN
  });
  const Component = ({ type }) => {
    if (displayFromIconfontCN) {
      return <IconFont type={type} />
    } else {
      const FishIcon = allIcons[type];
      return <FishIcon />
    }
  }
  useEffect(() => {
    if (displayFromIconfontCN) {
      const xhr = new XMLHttpRequest();
      xhr.open("GET", displayFromIconfontCN);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          var pattern = /icon-(?:[A-z]|[0-9]|-|_)*/g;
          setRenderData(xhr.response.match(pattern));
        }
      };
      xhr.send();
    }
  }, []);
  useEffect(() => {
    setBackgroundColor(currentColor);
    setSelectedColor(-1);
  }, [currentColor]);
  return (
    <div className="listStyle" >
      {showColorSelect ? (
        <div style={{width:'100%'}}>
          <ul className="colorUl">
            {ColorList.map((v, index) => (
              <div style={{ backgroundColor: v }} className="colorLi" onClick={() => { handleClick(index) }} key={v}>
                {index === selectedColor ? <PCheckOutlined className="checkIcon" /> : null}
              </div>
            ))}
          </ul>
        </div>
      ) : null}
      {renderData.map((v: any) => (
        <div
          key={v}
          className={
            v &&
              currentIcon &&
              v === currentIcon
              ? (showColorSelect && backgroundColor ? 'activeColor' : 'active')
              : ''
          }
          onClick={() => {
            if (readonly) return;
            if (setIconType) setIconType(v);
            if (iconChange) iconChange({ name: v, color: backgroundColor ? backgroundColor : '' });
          }}
          style={v && currentIcon && v === currentIcon ? { backgroundColor: backgroundColor } : null}
        >
          <Component type={v} />
        </div>
      ))}
    </div>
  );
};
export default IconList;


// WEBPACK FOOTER //
// ./src/components/icon-picker/IconList.tsx